export const name = 'components' as const

export const ComponentPropsExtenderSymbol = Symbol('ComponentPropsExtender')
